import angular from 'angular';
import constants from 'app/constants';
import {
  controlDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './sync-control-confirm-dialog.controller';
import template from './sync-control-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, control, controlType, isMultipleControls, controls,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'syncConfirmDialogVM',
      locals: {
        customerId,
        control,
        controlType,
        controls,
        isMultipleControls,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.controlAdmin.syncControlConfirmDialog', [
  alerts,
  controlDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('syncControlConfirmDialog', dialogService)
  .name;
